<svg
  viewBox="0 0 24 24"
  [style.width.px]="size"
  [style.height.px]="size"
  [attr.fill]="hasStroke ? 'none' : 'currentColor'"
  [attr.stroke]="hasStroke ? 'currentColor' : null"
  xmlns="http://www.w3.org/2000/svg"
  [innerHTML]="icon"
></svg>
